var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearchBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_search_blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6246633,14.2237529 L11.2590524,9.89072127 C12.1386904,8.65271222 12.594799,7.08891131 12.3667447,5.42737285 C11.9757945,2.6255629 9.69525152,0.410178282 6.86086238,0.149544798 C3.01651849,-0.241405429 -0.24140006,3.01651312 0.149550167,6.8934362 C0.410183651,9.69524616 2.62556827,12.0083683 5.42737822,12.3993186 C7.08891668,12.6273729 8.65271759,12.1712643 9.89072664,11.2916262 L14.2237583,15.6246579 C14.4192334,15.820133 14.7124461,15.820133 14.9079212,15.6246579 L15.5920841,14.940495 C15.7875592,14.7450199 15.7875592,14.4192281 15.6246633,14.2237529 L15.6246633,14.2237529 Z M2.07172211,6.27443168 C2.07172211,3.9613095 3.96131487,2.07171674 6.27443704,2.07171674 C8.58755922,2.07171674 10.477152,3.9613095 10.477152,6.27443168 C10.477152,8.58755385 8.58755922,10.4771466 6.27443704,10.4771466 C3.96131487,10.4771466 2.07172211,8.62013303 2.07172211,6.27443168 L2.07172211,6.27443168 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_search_blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search-icon"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#005082",
    mask: "url(#mask-2)",
    x: -0.941176471,
    y: -0.941176471,
    width: 16.9411765,
    height: 16.9411765
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlue);
export default __webpack_public_path__ + "static/media/icon_search_blue.ad22541481848c7370416fd816944029.svg";
export { ForwardRef as ReactComponent };